import Functions from "@/utils/functions.js";

export default {

    getToken() {
        return localStorage.getItem('token')
    },

    getRefToken() {
        return localStorage.getItem('ref_token')
    },

    getDataExpiredToken() {
        return localStorage.getItem('exp_data')
    },

    getAuthHeader() {
        return 'Bearer ' + this.getToken()
    },


    checkRemember() {
        return !!localStorage.getItem('ref_token')
    },

    checkAuth() {
        return !!localStorage.getItem('token')
    },

    // Decodifica il claim del ruolo direttamente dal JWT (senza dipendenze esterne).
    // Usato dalla guardia di rotta per un controllo di usabilità immediato, PRIMA
    // ancora che lo store Vuex (popolato da /user/info) sia disponibile dopo un
    // refresh di pagina. La vera barriera di sicurezza resta comunque il backend.
    getRole() {
        const token = this.getToken()
        if (!token) return null

        try {
            const payload = token.split('.')[1]
            const decoded = JSON.parse(
                decodeURIComponent(
                    atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
                        .split('')
                        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                )
            )
            return decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || decoded["role"] || null
        } catch {
            return null
        }
    },


    getExpiration(tokenExpiration) {

        var now = new Date();
        now.setMinutes(now.getMinutes() + Math.ceil((tokenExpiration / 60)))

        return Functions.DateFormat(now);
    },


    clearStorage() {

        localStorage.clear();
    },


    logout() {

        // Puliza storage
        this.clearStorage()
        sessionStorage.removeItem('embed_mode')

        // Pulisce lo state perchè ricarica la pagina
        window.location = '/login'

    },

    // ------------------------------------------------------------------
    // MODALITA' EMBED (nasconde toolbar/leftbar per l'integrazione in
    // webview di sistemi esterni). Flag in sessionStorage (non query string,
    // altrimenti si perderebbe navigando su sottopagine che non lo ripropagano,
    // e non localStorage, perché deve valere solo per la sessione corrente).
    // ------------------------------------------------------------------

    setEmbedMode() {
        sessionStorage.setItem('embed_mode', '1')
    },

    isEmbedMode() {
        return sessionStorage.getItem('embed_mode') === '1'
    },

    setStorage(data) {

        localStorage.setItem('token', data.access_token);
        localStorage.setItem('exp_data', this.getExpiration(data.expires_in))

        if (data.refresh_token)
            localStorage.setItem('ref_token', data.refresh_token)
    },

    // ------------------------------------------------------------------
    // IMPERSONIFICAZIONE (accesso "come utente" da parte del SuperAdmin)
    // ------------------------------------------------------------------

    // Salva la sessione SuperAdmin corrente PRIMA di sovrascriverla con quella
    // dell'utente impersonato, così è possibile tornare indietro.
    beginImpersonation() {
        const token = this.getToken()
        const refToken = this.getRefToken()
        const expData = this.getDataExpiredToken()

        if (token) localStorage.setItem('sa_token', token)
        if (refToken) localStorage.setItem('sa_ref_token', refToken)
        if (expData) localStorage.setItem('sa_exp_data', expData)
    },

    // Applica il token di impersonificazione. Niente refresh token: la sessione
    // non è rinnovabile silenziosamente, scade e basta (max 20 minuti lato backend).
    setImpersonationStorage(data) {
        localStorage.setItem('token', data.access_token)
        localStorage.setItem('exp_data', this.getExpiration(data.expires_in))
        localStorage.removeItem('ref_token')
        localStorage.setItem('impersonating', '1')
    },

    isImpersonating() {
        return localStorage.getItem('impersonating') === '1'
    },

    // Torna alla sessione SuperAdmin originale se presente, altrimenti fa un
    // logout normale. Ricarica la pagina per resettare completamente lo stato Vuex.
    endImpersonation() {
        const saToken = localStorage.getItem('sa_token')
        const saRef = localStorage.getItem('sa_ref_token')
        const saExp = localStorage.getItem('sa_exp_data')

        this.clearStorage()

        if (saToken) {
            localStorage.setItem('token', saToken)
            if (saRef) localStorage.setItem('ref_token', saRef)
            if (saExp) localStorage.setItem('exp_data', saExp)
            window.location = '/'
        } else {
            window.location = '/login'
        }
    },

}